import React from "react";

function ProductHome() {
  return (
    <div>
      <section className="product-home">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-center my-4 animate__animated animate__fadeInDown">
                منتجاتنا
              </h1>
            </div>
            <div className="col-6 my-2 wow animate__animated animate__fadeInUp">
              <img
                className="w-100 rounded"
                src="img/WhatsApp Image 2026-01-05 at 5.55.28 PM (1).jpeg"
                alt=""
              />
            </div>
            <div className="col-6 my-2 wow animate__animated animate__fadeInUp">
              <img
                className="w-100 rounded"
                src="img/WhatsApp Image 2026-01-05 at 5.55.28 PM (2).jpeg"
                alt=""
              />
            </div>
            <div className="col-6 my-2 wow animate__animated animate__fadeInUp">
              <img
                className="w-100 rounded"
                src="img/WhatsApp Image 2026-01-05 at 5.55.29 PM (2).jpeg"
                alt=""
              />
            </div>
            <div className="col-6 my-2 wow animate__animated animate__fadeInUp">
              <img
                className="w-100 rounded"
                src="img/WhatsApp Image 2026-01-05 at 5.55.29 PM (3).jpeg"
                alt=""
              />
            </div>
            <div className="col-6 my-2 m-auto wow animate__animated animate__fadeInUp">
              <img
                className="w-100 rounded"
                src="img/WhatsApp Image 2026-01-05 at 5.56.09 PM (1).jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ProductHome;
